module.exports={
	"Form": "SampleEditManifest",
	"Scope": "Sample-Edit",
	"Descriptors":
	{
		"SampleDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Sample-Edit-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Sample-Edit-Identity",
				"Group": "Sample-Edit-Identity"
			}
		},
		"SampleDetails.Name":
		{
			"Name": "Name",
			"Hash": "Sample-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Sample-Edit-Identity",
				"Group": "Sample-Edit-Identity"
			}
		},
		"SampleDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Sample-Edit-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Sample-Edit-Identity",
				"Group": "Sample-Edit-Identity"
			}
		},
		"SampleDetails.DesignatedTime":
		{
			"Name": "Designated Time",
			"Hash": "Sample-Edit-DesignatedTime",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.CaptureLatitude":
		{
			"Name": "Capture Latitude",
			"Hash": "Sample-Edit-CaptureLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.CaptureLongitude":
		{
			"Name": "Capture Longitude",
			"Hash": "Sample-Edit-CaptureLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "Sample-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"SampleDetails.ParentIDSample":
		{
			"Name": "Parent Sample",
			"Hash": "Sample-Edit-ParentIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Sample",
				"SearchFields":
				[
					"QRCode",
					"Name",
					"LabControlNumber",
					"LabReferenceNumber"
				]
			}
		},
		"SampleDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Sample-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"SampleDetails.IDProductionPlant":
		{
			"Name": "Production Plant",
			"Hash": "Sample-Edit-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "ProductionPlant",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"SampleDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "Sample-Edit-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				]
			}
		},
		"SampleDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Sample-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 12,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Status":
		{
			"Name": "Status",
			"Hash": "Sample-Edit-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.LabControlNumber":
		{
			"Name": "Lab Control Number",
			"Hash": "Sample-Edit-LabControlNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.LabReferenceNumber":
		{
			"Name": "Lab Reference Number",
			"Hash": "Sample-Edit-LabReferenceNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.ProductName":
		{
			"Name": "Product Name",
			"Hash": "Sample-Edit-ProductName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "Sample-Edit-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Sample-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"SampleDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Sample-Edit-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IntendedUse":
		{
			"Name": "Intended Use",
			"Hash": "Sample-Edit-IntendedUse",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "9",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.BuyUSA":
		{
			"Name": "Buy USA",
			"Hash": "Sample-Edit-BuyUSA",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "9",
				"Width": 3,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.ReceivedFrom":
		{
			"Name": "Received From",
			"Hash": "Sample-Edit-ReceivedFrom",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.GeographicalArea":
		{
			"Name": "Geographical Area",
			"Hash": "Sample-Edit-GeographicalArea",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Station":
		{
			"Name": "Station",
			"Hash": "Sample-Edit-Station",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "10",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Offset":
		{
			"Name": "Offset",
			"Hash": "Sample-Edit-Offset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.RepresentedQuantity":
		{
			"Name": "Represented Quantity",
			"Hash": "Sample-Edit-RepresentedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.SampledQuantity":
		{
			"Name": "Sampled Quantity",
			"Hash": "Sample-Edit-SampledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "11",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.SampledQuantityUnits":
		{
			"Name": "Sampled Quantity Units",
			"Hash": "Sample-Edit-SampledQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.RepresentedQuantityUnits":
		{
			"Name": "Represented Quantity Units",
			"Hash": "Sample-Edit-RepresentedQuantityUnits",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Units":
		{
			"Name": "Units",
			"Hash": "Sample-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "12",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.RequestedBy":
		{
			"Name": "Requested By",
			"Hash": "Sample-Edit-RequestedBy",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDSampleType":
		{
			"Name": "Sample Type",
			"Hash": "Sample-Edit-IDSampleType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "SampleType",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"SampleDetails.IDProduct":
		{
			"Name": "Product",
			"Hash": "Sample-Edit-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "13",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details",
				"Entity": "Product",
				"SearchFields":
				[
					"Name",
					"ManufacturerCode",
					"CatalogCode"
				]
			}
		},
		"SampleDetails.SampledByIDUser":
		{
			"Name": "Sampled By IDUser",
			"Hash": "Sample-Edit-SampledByIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.WitnessIDUser":
		{
			"Name": "Witness IDUser",
			"Hash": "Sample-Edit-WitnessIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.AuthorizedIDUser":
		{
			"Name": "Authorized IDUser",
			"Hash": "Sample-Edit-AuthorizedIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "14",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.CMSIDUser":
		{
			"Name": "CMSIDUser",
			"Hash": "Sample-Edit-CMSIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Datum":
		{
			"Name": "Datum",
			"Hash": "Sample-Edit-Datum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "15",
				"Width": 4,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Locked":
		{
			"Name": "Locked",
			"Hash": "Sample-Edit-Locked",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "15",
				"Width": 3,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.Sequenced":
		{
			"Name": "Sequenced",
			"Hash": "Sample-Edit-Sequenced",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "16",
				"Width": 3,
				"Section": "Sample-Edit-Details",
				"Group": "Sample-Edit-Details"
			}
		},
		"SampleDetails.IDSample":
		{
			"Name": "IDSample",
			"Hash": "Sample-Edit-IDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.GUIDSample":
		{
			"Name": "GUIDSample",
			"Hash": "Sample-Edit-GUIDSample",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Sample-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "17",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Sample-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Sample-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		},
		"SampleDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Sample-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "18",
				"Width": 4,
				"Section": "Sample-Edit-DataAudit",
				"Group": "Sample-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Sample-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Sample-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Sample-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Sample-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Sample-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Sample-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
